import React from 'react';
import BaseApi from '../../../api/BaseApi.js';
import ScreenCaption from '../../screen-caption.js';
import check from '../../../img/check.svg';
import emptybox from '../../../img/emptybox.svg';
import del from '../../../img/del.svg';


export default class ProjectProgramsScreen extends React.Component {
    constructor(props) {
        super(props);

        const args = props.args === undefined ? {} : props.args

        this.state = {
              args: args, 
              programs: []  
        }
    }  
    
    async componentDidMount() {
       this.updateData()
    }

    updateData() {
        BaseApi.get('/project/project/programs', {headers: {
            'Content-Type': 'application/json', 'SESSIONID' : sessionStorage.getItem("session")}, params: {id: this.props.args.project}, withCredentials: true})
        .then(res => {
            this.setState({programs: res.data})
        })    
        .catch(error=>console.log(error))
    }

    openProgram(id) {
        this.props.navigate("program", {caller: "projectprograms", callargs: this.state.args, program: id})
    }

    selectProgram() {
        this.props.navigate("projectprogram", {caller: "projectprograms", callargs: this.state.args, project: this.props.args.project})
    }

    switchProgramDevelopment(program) {
        var newProgram = program
        newProgram.development = !program.development 
        BaseApi.post('/project/program/link', newProgram, {headers: {
                   'Content-Type': 'application/json', 'SESSIONID' : sessionStorage.getItem("session")}, withCredentials: true})
               .then(res => {
                  this.setState(prevState => ({
                    programs: prevState.programs.map(p =>
                    p.id === program.programid
                        ? { ...p, development: newProgram}
                        : p
                    )
                }));
                   
               })
               .catch(error=>console.log(error))
    }

    deleteProgram(id) {
        BaseApi.delete('/project/program/link', {headers: {
                   'Content-Type': 'application/json', 'SESSIONID' : sessionStorage.getItem("session")}, params: {id: id},
                   withCredentials: true}).then(res => this.updateData())
    }

    renderProgram(program) {
        return (
            <tr
                id = {program.id}
                className="table-row-clickable"
                onClick={()=>this.openProgram(program.programid)}
            >
                <td style={{textAlign: 'left',  padding: '4px'}}>
                    {program.name}
                </td>
                <td style={{textAlign: 'left',  padding: '4px'}}>
                    {program.description}
                </td>

                <td   
                    onClick={(e)=> {
                        e.stopPropagation()
                        this.switchProgramDevelopment(program)
                    }}
                >
                    {program.development && <img src={check} height="16" width="16"/>}
                    {!program.development && <img src={emptybox} height="16" width="16"/>}
                </td>

                <td 
                    style={{textAlign: 'center'}}
                >
                    <button
                        className="btn btn-sm btn-outline-danger"
                        onClick={(e) => {
                            e.stopPropagation();        
                            this.deleteProgram(program.id);
                        }}
                    >
                        <img src={del} height="14" />
                    </button>
                </td>
            </tr>
        )      
    }

    render() {
        return (
            <div class="container">
                <ScreenCaption goback={this.props.goback} args={this.state.args} caption={"Программы"}/>
                 <div className="row mt-4 mb-3">
                    <div className="col-lg-5">
                        
                    </div>
                    <div className="col-lg-7 d-flex align-items-start justify-content-end mt-3 mt-lg-0">
                        <button
                            type="button"
                            className="btn btn-primary d-flex align-items-center"
                            onClick={() => this.selectProgram()}
                        >
                            Добавить программу
                        </button>
                    </div>
                 </div>
                <div className="card shadow-sm">
                    <div className="card-body p-0">
                        <div className="table-responsive">
                            <table className="table table-sm table-hover mb-0 align-middle">
                                <thead className="table-primary">
                                    <tr>
                                        <th id="nameCaption" style={{ cursor: 'pointer', whiteSpace: 'nowrap' }}>
                                            Наименование
                                        </th>
                                        <th id="descriptionCaption" style={{ cursor: 'pointer', whiteSpace: 'nowrap' }}>
                                            Описание
                                        </th>
                                        <th id="descriptionCaption" style={{ cursor: 'pointer', whiteSpace: 'nowrap' }}>
                                            Разработка
                                        </th>
                                         <th id="descriptionCaption" style={{ cursor: 'pointer', whiteSpace: 'nowrap' }}>
                                            Удалить из проекта
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {this.state.programs.map((value, index) => this.renderProgram(value))}
                                </tbody>
                            </table>      
                        </div>
                    </div>
                </div>        
            </div> 
        )
    }
}    


// WEBPACK FOOTER //
// ./src/ui/workspace-screens/project/projectprograms.js